var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJavascript(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 101,
    viewBox: "0 0 101 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.0546265 0.395508H100.055V100.396H0.0546265V0.395508Z",
    fill: "#F7DF1E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3484 83.9625L34.0007 79.3312C35.4773 81.9488 36.8202 84.1637 40.0417 84.1637C43.1296 84.1637 45.0769 82.9559 45.0769 78.2574V46.3051H54.4741V78.3902C54.4741 88.1234 48.7687 92.5539 40.4444 92.5539C32.9269 92.5539 28.5632 88.6605 26.348 83.9617M59.5784 82.9555L67.23 78.5254C69.2444 81.8148 71.8624 84.2312 76.4937 84.2312C80.3878 84.2312 82.8706 82.2844 82.8706 79.5992C82.8706 76.3773 80.3198 75.2359 76.0237 73.357L73.6749 72.3492C66.8948 69.4637 62.3976 65.8387 62.3976 58.1863C62.3976 51.1379 67.7675 45.7676 76.1585 45.7676C82.1327 45.7676 86.4288 47.8488 89.5163 53.2859L82.1991 57.9852C80.5878 55.0988 78.8433 53.9578 76.1581 53.9578C73.4058 53.9578 71.6605 55.7031 71.6605 57.9852C71.6605 60.8043 73.4058 61.9461 77.4331 63.6914L79.7823 64.698C87.7706 68.1219 92.2679 71.6121 92.2679 79.4652C92.2679 87.9238 85.6226 92.5551 76.6948 92.5551C67.9687 92.5551 62.33 88.3934 59.578 82.9559",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJavascript);
export default __webpack_public_path__ + "static/media/Javascript.8b97b17e7c580aaa84e77bbf0c0df373.svg";
export { ForwardRef as ReactComponent };